export const ItemHeadingAside: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <span className="text-inactive me-5">( </span>
      <span className="text-secondary">{children}</span>
      <span className="text-inactive ms-5"> )</span>
    </>
  );
};
